var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5004 9.4989C10.9206 9.4989 9.63672 10.7827 9.63672 12.3625C9.63672 13.9423 10.9206 15.2262 12.5004 15.2262C14.0801 15.2262 15.364 13.9423 15.364 12.3625C15.364 10.7827 14.0801 9.4989 12.5004 9.4989Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.501 5.20361C7.72824 5.20361 3.65235 8.17222 2.00098 12.3627C3.65235 16.5531 7.72824 19.5218 12.501 19.5218C17.2785 19.5218 21.3496 16.5531 23.001 12.3627C21.3496 8.17222 17.2785 5.20361 12.501 5.20361ZM12.501 17.1354C9.86643 17.1354 7.72824 14.9972 7.72824 12.3626C7.72824 9.72811 9.86643 7.58996 12.501 7.58996C15.1355 7.58996 17.2737 9.72815 17.2737 12.3627C17.2737 14.9972 15.1355 17.1354 12.501 17.1354Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/Visible.b4b2ed453d33ae7215d131afb1e408ca.svg";
export { ForwardRef as ReactComponent };